import WasteAcceptedList from "./WasteAcceptedList";

export default WasteAcceptedList;
